import {ApexFont, MapPosition} from "./interfaces";
import {Directions, MAX_MAP_POSITION, MIN_MAP_POSITION} from "./constants";
import fontMapData from "../data/ApexFontMap.json";

const apexMapData: ApexFont[] = fontMapData as ApexFont[];

export const getFontFromMap = (fontName: string): ApexFont | undefined =>
    apexMapData.find((item: ApexFont) => item._fontName === fontName);

export const cleanName = (name: string): string => name.replaceAll('.', '-')

const isPositionEmpty = (x: number, y: number): boolean =>
    Boolean(apexMapData.find(font => font.x === x && font.y === y) === undefined);

export const manhattanAdjacencyArray = (distance: number): MapPosition[] => {
    let array: MapPosition[] = [];
    for (let x = -distance; x <= distance; x++) {
        for (let y = -distance; y <= distance; y++) {
            if (x === 0 && y === 0) continue;
            array.push({x, y});
        }
    }
    return array;
};

export const cartesianAdjacencyArray = (distance: number): MapPosition[] => {
    let sqrDist = distance * distance;
    let array: MapPosition[] = [];
    let min = Math.ceil(-distance);
    let max = Math.floor(distance);
    for (let x = min; x <= max; x++) {
        for (let y = min; y <= max; y++) {
            if (x === 0 && y === 0) continue;
            if (sqrDist < x * x + y * y) continue;
            if (!isPositionEmpty(x, y)) array.push({x, y});
        }
    }
    return array;
};

export const getNeighbors = (x0: number, y0: number, adjacencyArray: MapPosition[]) => {
    return adjacencyArray.map(({x, y}) => {
        let xx = x + x0;
        if (xx < 0) xx = xx + 199;
        if (xx > 199) xx = xx - 199;

        let yy = y + y0;
        if (yy < 0) yy = yy + 199;
        if (yy > 199) yy = yy - 199;

        return {x: xx, y: yy};
    });
};


export const findNonEmptyForDirection = (X: number, Y: number, direction: string): MapPosition => {
    let found = false;
    let x = X;
    let y = Y;
    switch (direction) {
        case "RIGHT":
            while (!found) {
                if (x + 1 > MAX_MAP_POSITION) x = MIN_MAP_POSITION;
                else x++;
                found = !isPositionEmpty(x, y);
                if (found) break;
            }
            break;
        case "DOWN_RIGHT":
            while (!found) {
                if (x + 1 > MAX_MAP_POSITION) x = MIN_MAP_POSITION;
                else x++;
                if (y + 1 > MAX_MAP_POSITION) y = MIN_MAP_POSITION;
                else y++;
                found = !isPositionEmpty(x, y);
                if (found) break;
            }
            break;
        case "DOWN":
            while (!found) {
                if (y + 1 > MAX_MAP_POSITION) y = MIN_MAP_POSITION;
                else y++;
                found = !isPositionEmpty(x, y);
                if (found) break;
            }
            break;
        case "DOWN_LEFT":
            while (!found) {
                if (x - 1 < MIN_MAP_POSITION) x = MAX_MAP_POSITION;
                else x--;
                if (y + 1 > MAX_MAP_POSITION) y = MIN_MAP_POSITION;
                else y++;
                found = !isPositionEmpty(x, y);
                if (found) break;
            }
            break;
        case "LEFT":
            while (!found) {
                if (x - 1 < MIN_MAP_POSITION) x = MAX_MAP_POSITION;
                else x--;
                found = !isPositionEmpty(x, y);
                if (found) break;
            }
            break;
        case "UP_LEFT":
            while (!found) {
                if (x - 1 < MIN_MAP_POSITION) x = MAX_MAP_POSITION;
                else x--;
                if (y - 1 < MIN_MAP_POSITION) y = MAX_MAP_POSITION;
                else y--;
                found = !isPositionEmpty(x, y);
                if (found) break;
            }
            break;
        case "UP":
            while (!found) {
                if (y - 1 < MIN_MAP_POSITION) y = MAX_MAP_POSITION;
                else y--;
                found = !isPositionEmpty(x, y);
                if (found) break;
            }
            break;
        case "UP_RIGHT":
            while (!found) {
                if (x + 1 > MAX_MAP_POSITION) x = MIN_MAP_POSITION;
                else x++;
                if (y - 1 < MIN_MAP_POSITION) y = MAX_MAP_POSITION;
                else y--;
                found = !isPositionEmpty(x, y);
                if (found) break;
            }
            break;
    }
    return {x, y};
};


const nextX = (fromX: number, y: number): number => {
    let x = fromX;
    let found = false;
    while (!found) {
        found = !isPositionEmpty(x, y);
        if (found) return x;
        else {
            if (x + 1 > MAX_MAP_POSITION) x = MIN_MAP_POSITION;
            if (x - 1 < MIN_MAP_POSITION) x = MAX_MAP_POSITION;
            else x++;
        }
    }
    return x;
};

export function findSurroundingFonts(
    fromPosition: MapPosition,
    distance: number = 10): Array<ApexFont> {

    let fontArray: ApexFont[] = [];

    let startX = fromPosition.x;
    let startY = fromPosition.y;

    let count = 0;

    let font: ApexFont | undefined;

    for (let j = -distance; j <= distance; j++) {

        let isEmpty = font === undefined;
        console.log("nextX", nextX(startX + j, startY));
        let x = nextX(startX + j, startY);
        font = apexMapData.find(font => font.x === x && font.y === startY);
        if (font !== undefined && !fontArray.includes(font)) {
            fontArray.push(font);
            count++;
        }
        //console.log('count', count)
    }

    console.log("fontArray", fontArray);
    return fontArray;
}
